export default "__VITE_ASSET__CVSUfW9a__"